// Classifies a `callback` value as a same-host absolute URL ('deep-link'), a
// safe relative in-app path ('relative'), or invalid (to guard against
// open-redirect attacks to a different host).
//
// `value` is always the original callback string (useful for a full browser
// navigation via window.location.href). `path` is the relative path portion
// only, suitable for SPA navigation via history.push.
export const resolveCallback = callback => {
    if (!callback) {
        return null;
    }

    try {
        const url = new URL(callback);
        if (url.hostname === window.location.hostname) {
            return { type: 'deep-link', value: callback, path: url.pathname + url.search + url.hash };
        }
        return null;
    } catch {
        // Not an absolute URL - fall through to relative path check.
    }

    if (callback.startsWith('/') && !callback.startsWith('//')) {
        return { type: 'relative', value: callback, path: callback };
    }

    return null;
};
